import { LoadboardUsersDat } from "../LoadboardUsersDat";
import { LoadboardUsersDatRest } from "../LoadboardUsersDatRest";
import { LoadboardUsersTruckstop } from "../LoadboardUsersTruckstop";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPbwLoadboardServicesSlideout extends Layout {
    buttonAuthenticate: Button;
    buttonImportUsers: Button;
    buttonOrgAuthorize: Button;
    checkboxWeekendPosting: Switch;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    labelAssociatedUsers: Label;
    labelContactMethods: Label;
    labelLoadboardExclusions: Label;
    labelOrgAuthorizationStatus: Label;
    labelPostFrom: Label;
    labelPostingUser: Label;
    labelResult: Label;
    labelTo: Label;
    lastRepostDate: Textbox;
    layoutLoadboardUsersDat: LoadboardUsersDat;
    layoutLoadboardUsersDatRest: LoadboardUsersDatRest;
    layoutLoadboardUsersTruckstop: LoadboardUsersTruckstop;
    panelBasicInformation: Panel;
    panelDatContactMethods: Panel;
    panelDatRestUserTable: Panel;
    panelDatUserTable: Panel;
    panelLoadBoardExclusions1: Panel;
    panelLoadboardExclusions2: Panel;
    panelOptions: Panel;
    panelPostTiming: Panel;
    panelSftpOptions: Panel;
    panelTruckstop: Panel;
    panelTruckstopUserTable: Panel;
    sourceDispatchControl: DataSource;
    sourceOrganizationToken: DataSource;
    sourcePbwLoadboardServices: DataSource;
    sourceRateIndexControl: DataSource;
    switchIsActive: Switch;
    switchRepostEnabled: Switch;
    switchShowHideSftp: Switch;
    textboxAccountId: Textbox;
    textboxClientId: Textbox;
    textboxClientSecret: Textbox;
    textboxDatPrimaryContactMethod: Textbox;
    textboxDatSecondContactMethod: Textbox;
    textboxDaysAfterPickup: Textbox;
    textboxDaysPrior: Textbox;
    textboxDefaultPostingUserRole: Textbox;
    textboxDescription: Textbox;
    textboxExcludedBrokerageStatus: Textbox;
    textboxExcludedCommodityId: Textbox;
    textboxExcludedCustomerId: Textbox;
    textboxExcludedOrderMode: Textbox;
    textboxExcludedOrderTypeId: Textbox;
    textboxExcludedRevenueCodeId: Textbox;
    textboxLastPostingUpdate: Textbox;
    textboxPassword: Textbox;
    textboxPostingEnd: Textbox;
    textboxPostingFrequency: Textbox;
    textboxPostingStart: Textbox;
    textboxRemoteDirectory: Textbox;
    textboxRemotePort: Textbox;
    textboxServiceType: Textbox;
    textboxSftpFilePrefix: Textbox;
    textboxTranscorePassword: Textbox;
    textboxUrl: Textbox;
    textboxVendorUserId: Textbox;
}
